import NotificationList from './NotificationList';

const routes = [
  {
    index: true,
    element: <NotificationList />,
  },
];

export default routes;
export { NotificationList };
